import { gql } from '@apollo/client';
import CHANNEL from '../fragments/CHANNEL';
const ADD_CHANNEL = gql `
  mutation addChannel($name: String!, $description: String, $iconUrl: String, $userIds: [ID!]) {
    addChannel(name: $name, description: $description, iconUrl: $iconUrl, userIds: $userIds) {
      ...ChannelFragment
    }
  }
  ${CHANNEL}
`;
export default ADD_CHANNEL;
